// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"47fb20a1","620":"0dc28fa5","679":"5700c6cb"}[chunkId] + ".chunk.js";
};